import PropTypes from 'prop-types';

import { trans } from '@spotahome/soyuz/client';

import { formatVerificationDate } from '../../utils/dateUtils';

const CheckedInfo = ({ verificationDate }) => {
  if (!verificationDate) return null;

  return (
    <span
      dangerouslySetInnerHTML={{
        __html: trans('listing.verified.date_checked', {
          date: formatVerificationDate(verificationDate)
        })
      }}
    />
  );
};

CheckedInfo.propTypes = {
  verificationDate: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.oneOf([null])
  ]).isRequired
};

export default CheckedInfo;
